<template>
    <div>
        <div class="coupon-box" @click="ConversionEList">
            <p>使用e卡</p>
            <div style="width: 80%; display:flex;color:#666;align-items: center; justify-content: flex-end;">
                <span class="e-id" v-show="radioCoupon.join()">{{radioCoupon.join()}}</span>
                <span class="youhui" v-show="!radioCoupon.join()">选择e卡</span>
                <van-icon name="arrow" style="margin-left:.1rem;font-size:.24rem"/>
            </div>
        </div>
        <van-popup :style="{ height: '70%', }" :lock-scroll='true' v-model="showList" position="bottom">
            <div class="top-box">
                <div style="display:flex;justify-content:space-between">
                  <span></span>
                    <!-- <span style="color:#fff">x</span> -->
                    <span>E卡列表</span>
                    <!-- <van-icon @click="showList = false" name="cross" size=".3rem" style="padding-right:.2rem"/> -->
                  <span></span>
                </div>
            </div>
            <van-tabs v-model="active" @click="getData" :sticky='true' offset-top='1rem'>
                <van-tab>
                    <div class="box" :class="list.length>0?'active':'none'">
                        <div v-for="(item,i) in list" :key="i" class="coupon">
                            <div style="display:flex;align-items: center;">
                                <div style="margin-right:.2rem">
                                    <van-checkbox-group v-model="radioCoupon" @change="checkboxChange">
                                        <van-checkbox :name="item.id" checked-color="#FF355C"></van-checkbox>
                                    </van-checkbox-group>
                                </div>
                                <div style="width: 100%;">
                                    <p style="font-size:.22rem">卡号:<span style="font-size:.32rem">{{item.id}}</span></p>
                                    <div class="main">
                                        <p style="color:red;font-size:.22rem;flex: 3;height:.4rem;line-height:.40rem">余额:<span style="font-size:.32rem">{{item.price}}</span></p>
                                        <p style="color:#999;font-size:.22rem;flex: 2;height:.4rem;line-height:.40rem">{{'初始面值:' + item.original_price}}</p>
                                    </div>
                                     <div class="">
                                        <p style="color:#999;font-size:.22rem;height:.7rem;line-height:.90rem;">{{'过期时间:'+item.expired_at}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
            <van-goods-action style="width: 94%;margin: 0 auto;">
                <van-goods-action-button type="danger" text="不使用e卡" @click="notUse" color="#FF8C27" />
                <van-goods-action-button @click="hideEList"  color="#FF355C" type="warning" text="完成" />
            </van-goods-action>
            </van-popup>
    </div>
</template>

<script>
    import localStor from '../../utils/ls'
    import { Dialog } from 'vant';
    export default {
        props:['discountExpressFee','discountType','showDataAddress', 'shopCartList'],
        data(){
            return{
                configInfo: JSON.parse(localStorage.getItem("configInfo")) || {},
                showList:false,
                shopCart: localStor.get('result') || [], //购物车传来的商品
                shopDetailId:localStor.get("shopDetailId") || '',
                cartShopArr:localStor.get("result") || [] ,//购物车
                payDetail:localStor.get("payDetail") || {} ,
                cppdId:'',
                list:[],
                notList:[],
                value:'',
                active: 0,
                couponPoints:0,
                couponPrice:0,
                couponFreight:0,
                couponExpress:'',
                radioCoupon: [],
                couponSta:'',
                express:0,//是否显示优惠运费
                isHide: false
            }
        },
        mounted(){
            if(this.configInfo.is_crop_ePay == 1){
                this.getData()
            }
        },
        methods:{
            notUse(){
                this.showList = false
                this.radioCoupon = []
                this.$parent.cardPay = ''
            },
            ConversionEList(){
                this.showList = true
            },
            getData(){
                this.$axios({
                    method: "POST",
                    url: "/corp/ecard/list",
                    success: data => {
                        if (data.data.status == 'success') {
                            this.list = data.data.data
                        } else {
                            this.$toast(data.data.message)
                        }
                    }
                });
            },
            hideEList() {
              this.isHide = true
              this.showList = false
              this.$parent.cardPay = this.radioCoupon.join()
            },
            checkboxChange(val) {
              let num = 0
              this.list.forEach(item => {
                if (val.find(id => item.id == id)) {
                  num += (Number(item.price))
                }
              })
              this.$parent.cardPayNum = num
            }
        },
        watch: {
          'showList': {
            handler(a, b) {
              if (!a && !this.isHide) {
                this.radioCoupon = []
                this.$parent.cardPay = ''
                this.$parent.cardPayNum = ''
              }
              if (this.isHide) {
                this.isHide = false
              }
            }
          }
        }
    }
</script>

<style scoped>
.coupon-box{
    background:#fff;
    padding: .2rem;
    display:flex;
    justify-content: space-between;
}
.add-btn{
    position:fixed;
    bottom:.2rem;
    height:.75rem;
    line-height: .75rem;
    color: rgb(255, 255, 255);
    background: #FF8C27;
    border-color: #FF8C27;
    width: 95%;
    margin:0 2.5%;
    border-radius: .08rem;
}
.box{
    background: #F6F6F6;
    color: #333;
}
.active{
    padding: .2rem 0;
    margin-bottom: 1rem;
}
.coupon{
    padding: .2rem;
    background: #fff;
    margin: .2rem;
    border-radius:0.10rem;
    border-top: .10rem solid #f2b2d2;
}
.main{
    display:flex;
    margin-top:.2rem;
    font-size:.24rem ;
    color: #333;
}
.top-box{
    position: fixed;
    z-index: 99;
    background: #ff355b;
    color: #fff;
    width: 100%;
    text-align: center;
    padding: .2rem 0;
}
.youhui{
    color:#ff355b;
    border:.01rem solid #ff6280;
    background:#ffe5e7;
    padding:.02rem .1rem;
    font-size: .2rem
}
.e-id {
  overflow:hidden;
	text-overflow:ellipsis;
	white-space:nowrap
}
</style>



// WEBPACK FOOTER //
// src/components/address/ConversionEList.vue